import React from "react";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";
import { initializeAnalytics } from "./utils/analytics";
import "./reset.css";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

// Initialize Sentry as early as possible (from your getting started guide)
Sentry.init({
  dsn: "https://e84ae9885ba60bd897025a31e954b02b@o1274155.ingest.us.sentry.io/4509838848360448",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  environment: process.env.NODE_ENV,
});

// Initialize Amplitude analytics
initializeAnalytics();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
